export default "__VITE_ASSET__CDHrWaof__"